
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CancelOfferDetailsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CancelOfferDetails"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"offerCopy"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"offerPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalPrice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingPeriod"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":116}};
    doc.loc.source = {"body":"fragment CancelOfferDetailsFields on CancelOfferDetails {\n  offerCopy\n  offerPrice\n  originalPrice\n  billingPeriod\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    
